<div class="fluid-container">
  <div class="row pt-3 d-flex align-items-center">
    <div class="col-md-8 mb-2 step-title">
      <div class="w-100 d-flex">
        <h5 class="mb-0">Beneficiary Personal Information</h5>
      </div>
    </div>
    <div class="col-md-4 editBtn headerSubPortion px-0">
      <ul>
        <li class="col-auto px-0 firstPortion">
          <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
        </li>
        <li class="col-auto pr-0 pl-2 secondPortion">
          <lib-maximize-dialog-library
            [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
          <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
        </li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 p-0">

      <lib-assigning-task-library [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event)">
      </lib-assigning-task-library>
    </div>
  </div>
  <p-divider></p-divider>

  <div class="row">
    <div class="col-md-6">
      <h5 class="labelText">Personal Details</h5>
    </div>
  </div>


  <lib-generic-beneficiary-personal-details-library (personalDetails)="personalDetail($event)"
    (profileEditStatus)="onEditClicked($event)" [detailsAbout]="selectedDetailAbout" (hasPassportChange)="onHasPassportChange($event)
    " [editMode]="personalDetailsEdit" [isShowProfilePic]="false"  [isShowVerify]="true"  [passportShow]="true" [isEditDisabled]="disabledControls"></lib-generic-beneficiary-personal-details-library>

  <p-divider></p-divider>
  <div class="row pt-3">
    <div class="col-md-6"></div>
    <div class="col-md-6">
      <gc-status-update [stepDetails]="stepDetails" [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></gc-status-update>
    </div>
  </div>
</div>